import { CART_RENDER_AND_PREFETCH_OPTIMIZATIONS_240627 } from "@faire/web-api/indigofair/settings/CART_RENDER_AND_PREFETCH_OPTIMIZATIONS_240627";

import {
  getSettingValueWithoutAssignment,
  assignSetting,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingCartRenderAndPrefetchOptimizations = () =>
  getSettingValueWithoutAssignment(
    CART_RENDER_AND_PREFETCH_OPTIMIZATIONS_240627,
    false
  );

export const assignSettingCartRenderAndPrefetchOptimizations = () =>
  assignSetting(CART_RENDER_AND_PREFETCH_OPTIMIZATIONS_240627);
